import container from './CQRS';

const { queriesController, commandsController } = container;

async function getModulesInfo() {
  try {
    return await queriesController.fetchModulesInfo();
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to obtain the task priorities...');
  }
}

async function setModuleFocusOn(childId, body) {
  const ModuleOrder = {
    ModuleOrder: body.ModuleOrder,
  };
  try {
    return await commandsController.setModuleFocusOn({ childId, ModuleOrder });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not save the on focus module.');
  }
}

async function setInitialSetup(childId, body) {
  const initialSetup = {
    hour: body.hour,
    timeDay: body.timeDay,
  };
  try {
    return await commandsController.setInitialSetup({ childId, initialSetup });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not save the initial setup.');
  }
}
async function setDisableFirstTime(userId, body) {
  const firstTime = {
    is_child: body.isChild,
    user_id: userId,
  };
  try {
    return await commandsController.setDisableFirstTime({ firstTime });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not save the initial setup.');
  }
}

export { getModulesInfo, setModuleFocusOn, setInitialSetup, setDisableFirstTime };
